export class SliderModel {
    public InputValue: number;
    public SliderValue: number;
    public ShowError: boolean;
    public WithoutErrorMin: number;
    public WithoutErrorMax: number;
    public MaxValue: number;
    public SecondMaxValue: number;
    public MinValue: number;
    public SecondMinValue: number;
    public InputSliderCoef: number;
    public RealValue: number;
    public MinRealValue: number;
    public RealValueError: boolean;
    public CaloriesDividedOnGram: number;
    public GramDividedOnKGramMin: number;
    public GramDividedOnKGramMax: number;
    public GramMin: number;
    public GramMax: number;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/slider-model.ts